import appleStore from "assets/images/mobile/apple-store.png";
import googlePlay from "assets/images/mobile/google-play.png";

const MobileSystem = {
    Android : {
        img:googlePlay,
        url:"https://play.google.com/store/apps/details?id=com.zapmanager"
    },
    IOS : {
        img:appleStore, 
        url:"https://apps.apple.com/il/app/zap-manager-%D7%96%D7%90%D7%A4-%D7%9E%D7%A0%D7%92%D7%A8/id1570416438"
    }
};

export const getMobileOperatingSystem =()=> {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return MobileSystem.Android //"Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return MobileSystem.Android//"Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return MobileSystem.IOS//"iOS";
    }

    return MobileSystem.Android//"unknown";
}

export default Object.freeze(MobileSystem);